import React from 'react';
import { Link } from 'react-router-dom';
import { Mic, LogIn, ArrowRight, Wand2, Headphones } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import styles from './ActionBoxes.module.css';

const ActionBoxes = () => {
    const { user } = useAuth();

    const boxes = [
        {
            title: 'Speech Practice',
            description: 'Record and analyze your presentation delivery',
            icon: <Mic size={20} />,
            route: '/practice',
            buttonText: 'Start Analysis'
        },
        {
            title: 'Content Generation',
            description: 'Generate presentation content with AI assistance',
            icon: <Wand2 size={20} />,
            route: '/create',
            buttonText: 'Create Content'
        },
        {
            title: 'Session History',
            description: 'Review and analyze your past presentations',
            icon: <Headphones size={20} />,
            route: '/recordings',
            buttonText: 'View History'
        }
    ];

    if (!user) {
        return (
            <div className={styles.container}>
                <div className={styles.loginPrompt}>
                    <div className={styles.loginIconWrapper}>
                        <LogIn size={24} className={styles.loginIcon} />
                    </div>
                    <h3>Access Enterprise Features</h3>
                    <p>Sign in to access advanced presentation analytics and training tools</p>
                    <Link to="/login" className={styles.loginButton}>
                        Sign In to Continue
                    </Link>
                </div>
            </div>
        );
    }

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <h2 className={styles.title}>Available Tools</h2>
            </div>
            <div className={styles.content}>
                <div className={styles.actionsGrid}>
                    {boxes.map((box) => (
                        <Link key={box.route} to={box.route} className={styles.actionCard}>
                            <div className={styles.iconWrapper}>{box.icon}</div>
                            <div className={styles.contentWrapper}>
                                <h3 className={styles.cardTitle}>{box.title}</h3>
                                <p className={styles.description}>{box.description}</p>
                            </div>
                            <div className={styles.arrow}>
                                <ArrowRight size={16} />
                            </div>
                        </Link>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ActionBoxes;